import request from '@/utils/request.js'

export function addRole(data){
    return request({
        url: 'channel/app/add',
        method: 'post',
        data
    })
}

export function getRoleListPage(data){
    return request({
        url: 'channel/app/listPage',
        method: 'post',
        data: data
    })
}

export function editRoleInfo(data){
    return request({
        url: 'channel/app/update',
        method: 'post',
        data
    })
}

export function getOneRoleInfo(data){
    return request({
        url: 'channel/app/detail',
        method: 'post',
        data
    })
}

export function changeRoleState(data){
    return request({
        url: 'channel/app/state',
        method: 'post',
        data
    })
}

export function getMenuList(){
    return request({
        url: 'menu/app/list',
        method: 'post',
        data: {}
    })
}

export function getAllMenuList() {
    return request({
        url: 'menu/app/allList',
        method: 'post',
        data: {}
    })
}

export function getMenuDetail(data) {
    return request({
        url: 'menu/app/detail',
        method: 'post',
        data
    })
}

/***
 一级菜单下拉选项
*/
export function getFirstMenuList() {
    return request({
        url: 'menu/app/first',
        method: 'post',
        data:{}
    })
}

/**
 * 更新菜单
 * */
export function updateMenu(data) {
    return request({
        url: 'menu/app/update',
        method: 'post',
        data
    })
}

/***
 * 修改状态
 */
export function updateMenuState(data) {
    return request({
        url: 'menu/app/state',
        method: 'post',
        data
    })
}

/***
 * 添加菜单
 */
export function addMenuHandle(data) {
    return request({
        url: 'menu/app/add',
        method: 'post',
        data
    })
}

/***
 * 获取图片数组
 */
export function getAllImage() {
    return request({
        url: 'menu/app/photo/list',
        method: 'post',
        data:{}
    })
}

// 店铺活动
export function getSmokeSearchList() {
    return request({
        url: 'smoke/search/list',
        method: 'post',
        data:{}
    })
}
// 店铺列表
export function getSmokeList(data) {
    return request({
        url: 'smoke/list',
        method: 'post',
        data
    })
}
// 店铺新增
export function getSmokeInsert(data) {
    return request({
        url: '/smoke/insert',
        method: 'post',
        data
    })
}
// 店铺修改
export function getSmokeUpdate(data) {
    return request({
        url: '/smoke/update',
        method: 'post',
        data
    })
}